module.exports = __webpack_public_path__ + "img/t3s.70ce3590.svg";